module.exports = __webpack_public_path__ + "static/media/IKMS04.6718e8e0.jpg";